module.exports = "pegasus/assets/x_gray_icon.png";